/**
 * L'ancre est opaque pour le backend : il la stocke et la renvoie telle quelle,
 * sans jamais l'inspecter ni la valider. Le contrat est donc entièrement défini
 * ici, et toute évolution de forme doit rester rétro-compatible en lecture :
 * des notes écrites avec l'ancienne forme resteront en base.
 */

export interface TextQuoteSelector {
	type: "TextQuoteSelector";
	/** Le texte sélectionné, après normalisation (cf. ProtocolAnchorService). */
	exact: string;
	prefix?: string;
	suffix?: string;
}

/** Repli utilisé quand le texte apparaît plusieurs fois ou a légèrement bougé. */
export interface BlockOffsetSelector {
	type: "BlockOffset";
	blockId: string;
	offsetStart: number;
	offsetEnd: number;
}

export type ProtocolNoteTextAnchor = TextQuoteSelector & { secondary?: BlockOffsetSelector };

/** `{}` est la valeur renvoyée par l'API pour une note sans sélection. */
export type ProtocolNoteAnchor = ProtocolNoteTextAnchor | Record<string, never>;

export const EMPTY_PROTOCOL_NOTE_ANCHOR: ProtocolNoteAnchor = {};

export function isTextQuoteAnchor(anchor: ProtocolNoteAnchor | undefined): anchor is ProtocolNoteTextAnchor {
	return (
		anchor != null &&
		(anchor as ProtocolNoteTextAnchor).type === "TextQuoteSelector" &&
		typeof (anchor as ProtocolNoteTextAnchor).exact === "string" &&
		(anchor as ProtocolNoteTextAnchor).exact.length > 0
	);
}
